/**
 * Header nav: touch (two-tap) behaviour and keyboard tab order.
 * - Touch: first tap opens mega/dropdown, second tap navigates (desktop + coarse pointer only).
 * - Tab order: mega panels are moved in the DOM so focus cycles through each mega’s links
 *   before moving to the next top-level item.
 */
(function () {
  const desktop = window.matchMedia('(min-width: 768px)');
  const coarse = window.matchMedia('(pointer: coarse)');

  function shouldRunTouch() {
    return desktop.matches && coarse.matches;
  }

  /**
   * Move each mega menu panel in the DOM to sit right after its trigger (nav item).
   * Tab order then becomes: trigger 1 → mega 1 links → trigger 2 → mega 2 links → …
   */
  function reorderMegasForTabOrder(headerNav) {
    const megas = headerNav.querySelectorAll('[data-mega-menu]');
    megas.forEach((mega) => {
      const handle = mega.getAttribute('data-mega-menu');
      if (!handle) return;
      const trigger = headerNav.querySelector(
        `.nav-item[data-link-handle="${handle}"], details[data-link-handle="${handle}"]`
      );
      if (!trigger || trigger.nextElementSibling === mega) return;
      trigger.insertAdjacentElement('afterend', mega);
    });
  }

  function navItemHasPanel(headerNav, navItem) {
    const handle = navItem.dataset?.linkHandle;
    if (!handle) return false;
    const hasDropdown = navItem.querySelector('.dropdown-menu');
    const hasMega = headerNav.querySelector(`[data-mega-menu="${handle}"]`);
    return Boolean(hasDropdown || hasMega);
  }

  function closeAll(headerNav) {
    if (!headerNav) return;
    headerNav.querySelectorAll('.nav-item.open').forEach((el) => el.classList.remove('open'));
  }

  function handleLinkClick(e) {
    const headerNav = document.querySelector('.header-nav');
    if (!headerNav || !shouldRunTouch()) return;

    const link = e.target.closest('a[href]');
    if (!link) return;

    const navItem = link.closest('.nav-item');
    if (!navItem || !navItem.closest('.header-nav')) return;
    if (!navItemHasPanel(headerNav, navItem)) return;

    if (navItem.classList.contains('open')) {
      // Second tap: allow navigation (do not preventDefault)
      closeAll(headerNav);
      return;
    }

    // First tap: open panel, prevent navigation
    e.preventDefault();
    headerNav.querySelectorAll('.nav-item.open').forEach((el) => el.classList.remove('open'));
    navItem.classList.add('open');
  }

  function handleDocumentClick(e) {
    const headerNav = document.querySelector('.header-nav');
    if (!headerNav || !shouldRunTouch()) return;
    if (e.target.closest('.header-nav')) return;
    closeAll(headerNav);
  }

  function handleEscape(e) {
    if (e.key !== 'Escape') return;
    closeAll(document.querySelector('.header-nav'));
  }

  function init() {
    const headerNav = document.querySelector('.header-nav');
    if (!headerNav) return;

    reorderMegasForTabOrder(headerNav);

    headerNav.addEventListener('click', handleLinkClick, true);
    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('keydown', handleEscape);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
